import { useDirection } from '@hilma/netina2all';
import { useI18n } from '../../hooks';

import { RecommendersResponse } from '../../types';

interface RecommenderProps {
	recommender: RecommendersResponse;
}

const Recommender: React.FC<RecommenderProps> = ({ recommender }) => {

	const alts = useI18n(i18n => i18n.alts);

	const direction = useDirection();

	return (
		<div className='recommender'>
			<img className='recommender-image' src={recommender.imagePath} alt={alts.recommender} />
			<div>{recommender.role} {recommender.recommenderName}
			</div>
			<div className='recommendation' >
				<strong dir={direction}>
					{(recommender.quote[0] === '"' ? '' : '"') +
						recommender.quote +
						(recommender.quote[recommender.quote.length - 1] === '"' ? '' : '"')}
				</strong>
			</div>
		</div>
	)
}

export default Recommender;